import React from 'react';
import './Faq.css'; 
import Header from './Header';
import Footer from '../global/Footer';

const Faq = () => {
  return (
    <>
    <Header/>
    <div className="faq-container">
      <div className="faq-header">
        Frequently Asked Questions
      </div>
      <div className="faq-content">
        <h2>General Disclaimer</h2>
        <p>
          No third party agency is working on behalf of SEVA Srijan Foundation for any recruitment, training, camps or other activities related to SEVA Srijan Foundation. 
          Please check/consult with SEVA Srijan Foundation directly to get correct information or assistance. 
          Please beware of any unwarranted claims made by anyone on our behalf. Kindly bring any such claims to our notice for immediate attention and action. 
          SEVA Srijan Foundation doesn’t charge any money from anyone for these activities. 
          So if you come across any individual/organization making a monetary demand in our name please bring it to our notice immediately on 
          <a href="mailto:sevasrijanfoundation@gmail.com"> sevasrijanfoundation@gmail.com</a> or call us on 9717927771 / 8527298877.
        </p>
      </div>
      <div className="faq-item">
        <h3>How does SEVA Srijan Foundation make a difference?</h3>
        <p>
        SEVA Srijan Foundation is an organization dedicated to the empowerment and development of the underprivileged/marginalized children and youth. Its uniqueness lies in its various initiatives, programmes, and projects for community upliftment through education, aftercare, skill development and talent bank development.
        </p>
      </div>
      <div className="faq-item">
        <h3>Who are the people behind SEVA Srijan Foundation?</h3>
        <p>
        SEVA Srijan Foundation is driven by a dedicated team of professionals, volunteers, and individuals who are passionate about creating a positive impact on society by transforming the lives of children and youth. 
        </p>
      </div>
      <div className="faq-item">
        <h3>How can I get involved with your NGO?</h3>
        <p>
        There are various ways to get involved with SEVA Srijan Foundation.
i.	Volunteer: We offer volunteering opportunities in different capacities. Visit our volunteer page on the website for more information.
ii.	Donate: Your generous contributions help us carry out our initiatives effectively. You can find donation options on our website.
iii.	Spread the word: Follow us on social media, share our posts, and help raise awareness about the cause we work for.
iv.	Collaborate: If you represent an organization or have an idea for a partnership, reach out to us for exploring collaboration opportunities.

        </p>
      </div>
      <div className="faq-item">
        <h3>How can I contribute to this organization?</h3>
        <p>
        You can contribute by sponsoring a child, by making general donation, by convincing your friends, company or other companies to provide corporate funding to SSF. You can join us and provide voluntary services and donate as you wish. 
        </p>
      </div>
      <div className="faq-item">
        <h3>Can I meet the sponsored child and get to know about his/her progress?</h3>
        <p>
        Yes, you can meet the sponsored child discreetly as per SSF Policy on Sponsorship/Mentorship of Children. You may visit one of our programs on a scheduled donor visit. Also, we can update you about child’s progress from time to time through our website, emails and SMSs.
        </p>
      </div>
      <div className="faq-item">
        <h3>Do I get tax benefits on donations made to the organization?</h3>
        <p>
        All donations made to the organization are exempted U/s 80G & 12A of the Income Tax Act, 1961. All donors are provided with receipts for their contribution.
        </p>
      </div>
      <div className="faq-item">
        <h3>Do you share donor’s information with other organizations?</h3>
        <p>
        No, we do not share donor’s information with any other organization under our privacy policy.
        </p>
      </div>
      <div className="faq-item">
        <h3>Do you accept donations in form of books/ gadgets / furniture?</h3>
        <p>
        Yes. We do accept donations in kinds like books, computers and food supplies.
        </p>
      </div>
      <div className="faq-item">
        <h3>How much should I donate?</h3>
        <p>
        The donation amount is entirely up to you. SSF appreciates any contribution, big or small, as every bit counts towards making a positive impact.
        </p>
      </div>
      <div className="faq-item">
        <h3>How can I volunteer at SEVA Srijan Foundation?</h3>
        <p>
        Visit our “Support Us” page to submit your information and resume.
        </p>
      </div>
      <div className="faq-item">
        <h3>How can I intern at SEVA Srijan Foundation?</h3>
        <p>
        We offer internships year-round that provide work experience and personal development. Details about the internship program, including application procedures and requirements, can be found on our website. Look for the “Internships” or “Join Us” section for more information.
        </p>
      </div>
      <div className="faq-item">
        <h3>How does SEVA Srijan Foundation ensure that the donor’s contribution is being utilized in the intended way?</h3>
        <p>
        SSF maintains transparency and accountability in its operations. Regular audits and financial reporting ensure that the donor’s contribution is utilized appropriately and in alignment with the organization’s mission and objectives.
        </p>
      </div>
      <div className="faq-item">
        <h3>What will SEVA Srijan Foundation do with my donation?</h3>
        <p>
        Your donation will be used to support SSF’s various programmes and initiatives aimed at empowering the youth, promoting education, fostering the development of a equitable society through creation of employment opportunities and uplifting communities by development of good citizenry. You may also contribute to the cause that is close to your heart.
        </p>
      </div>
      <div className="faq-header">
        Scheduling A Visit To SEVA Srijan Foundation
      </div>
      <div className="faq-item">
        <h3>I want to see your processing center in Delhi. Who should I coordinate with, for this?</h3>
        <p>
          Please Contact SEVA Srijan Foundation to schedule your visit during our working hours i.e Monday – Saturday (10 am – 5 pm, lunch hours 1.30 pm – 2.30 pm).
          In Delhi, our address is – SEVA Srijan Foundation Plot # 76, Bhagrati Niwas, Main Mandi Road, Village-Jaunapur, New Delhi-110047.
          Please call on  9717927771 / 8527298877 for any assistance regarding directions etc.
        </p>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Faq;
